import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { UserProfile } from '../models/user-profile.model';
import { BEARER_ONLY, BYPASS_HEAD } from '../interceptor/token.interceptor';
@Injectable({
  providedIn: 'root',
})
export class VoucherService {

  constructor(
    private http: HttpClient
  ) { }

  getVoucherList(): Observable<any> {
    return this.http
      .get<UserProfile>(environment.apiUrl + 'api/v1/mobile/vouchers/list');
  }
}
